import { useCallback, useEffect, useState } from 'react';

export type Skin = 'arcade' | 'inevitrade';
export const SKINS: { id: Skin; name: string }[] = [
  { id: 'arcade', name: "Wizard's Grimoire" },
  { id: 'inevitrade', name: 'Inevitrade' },
];

const KEY = 'paladin-skin';
const isSkin = (s: string | null): s is Skin => s === 'arcade' || s === 'inevitrade';
const read = (): Skin => {
  // ?skin= pins a frame to one skin without touching the saved choice (used by the mosaic preview)
  const pinned = new URLSearchParams(window.location.search).get('skin');
  if (isSkin(pinned)) return pinned;
  try { const s = localStorage.getItem(KEY); return s === 'arcade' ? s : 'inevitrade'; } catch { return 'inevitrade'; }
};

/** Active skin, applied as data-skin on <html> so every --pal-* token follows it. */
export function useSkin() {
  const [skin, setSkinState] = useState<Skin>(read);
  useEffect(() => { document.documentElement.dataset.skin = skin; }, [skin]);
  useEffect(() => {
    const onChange = () => setSkinState(read());
    window.addEventListener('paladin-skin', onChange);
    return () => window.removeEventListener('paladin-skin', onChange);
  }, []);
  const setSkin = useCallback((s: Skin) => {
    try { localStorage.setItem(KEY, s); } catch { /* per-page only */ }
    setSkinState(s);
    window.dispatchEvent(new Event('paladin-skin'));
  }, []);
  return { skin, setSkin };
}
